// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/components/actions/Button.jsx

import React, { forwardRef } from "react";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

const Button = forwardRef(function Button(
  {
    children,
    variant = "secondary",
    size = "medium",
    loading = false,
    loadingLabel = "Working…",
    iconBefore = null,
    iconAfter = null,
    fullWidth = false,
    className = "",
    disabled = false,
    type = "button",
    ...buttonProps
  },
  ref
) {
  const isDisabled = disabled || loading;

  return (
    <button
      {...buttonProps}
      ref={ref}
      type={type}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      className={joinClassNames(
        "oasys-button",
        `oasys-button--${variant}`,
        `oasys-button--${size}`,
        fullWidth && "oasys-button--full-width",
        loading && "oasys-button--loading",
        className
      )}
    >
      {loading ? (
        <span className="oasys-button__spinner" aria-hidden="true" />
      ) : (
        iconBefore
      )}

      <span className="oasys-button__label">
        {loading ? loadingLabel : children}
      </span>

      {!loading ? iconAfter : null}
    </button>
  );
});

export default Button;
